import { useCallback, useEffect } from "react";
import { useGifStore } from "@/common/store/gifStore";
import { useUsersStore } from "@/common/store/storeUsers";
import { useNichesStore } from "@/common/store/storeNiches";
import { apiGifs } from "../services";
import { useFetch } from "./useFetch";

interface IUseCachedGif {
  gifId: string;
}

export const useCachedGif = ({ gifId }: IUseCachedGif) => {
  const gif = useGifStore(state => state.getGifById(gifId));
  const updateGifs = useGifStore(state => state.updateGifs);
  const updateUsers = useUsersStore(state => state.updateUsers);
  const updateNiches = useNichesStore(state => state.updateNiches);

  const fetchGif = useCallback(() => apiGifs.fetchGifById(gifId), [gifId]);

  const { isLoading, error, data } = useFetch(fetchGif, !gif);

  useEffect(() => {
    if (!error && data) {
      const aliasPattern = /^\d*$/;
      const aliasId = aliasPattern.test(gifId) ? gifId : undefined;
      updateGifs([{ ...data.gif, aliasId }]);
      updateUsers(data.user ? [data.user] : []);
      updateNiches(data.niches);
    }
  }, [gifId, data, error, updateGifs, updateUsers, updateNiches]);

  return {
    gif,
    isLoading,
    error,
  };
};
